import {AbstractEntity, AbstractEntityData} from './AbstractEntity';

export interface CatalogTocEntityData extends AbstractEntityData {
  label: string;
  page: number;
}

export class CatalogTocEntity extends AbstractEntity<CatalogTocEntityData> {
  get label(): string {
    return this.data.label;
  }

  get page(): number {
    return this.data.page;
  }
}
